import React from 'react';
import { useLanguage } from '@/language/LanguageContext';
import { Button } from '@/components/ui/button';

export const LanguageSwitcher = ({ className = '' }) => {
  const { language, toggleLanguage } = useLanguage();

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={toggleLanguage}
      className={`text-muted-foreground hover:text-foreground transition-colors font-light tracking-wide ${className}`}
    >
      <span className={language === 'en' ? 'text-foreground' : 'text-muted-foreground'}>
        EN
      </span>
      <span className="mx-1 text-muted-foreground/50">/</span>
      <span className={language === 'pl' ? 'text-foreground' : 'text-muted-foreground'}>
        PL
      </span>
    </Button>
  );
};
